const CategoryValidation = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = "The name is required";
  }
  if (!values.status) {
    // You can return translation keys
    errors.status = "Status is required";
  }

  return errors;
};

export default CategoryValidation;
